import React, {useEffect} from 'react';
import {TopBar} from '../common/TopBar';
import {Sidebar} from '../common/Sidebar';

export const FaqPage = (props) => {

  useEffect(() => {
    // const div = document.createElement('div');
    // const elem = 'data-onload';
    // div.class = "g-signin2";
    // div['data-onload'] = renderButton();
  
    // document.body.appendChild(div);
    // return () => {
    //   document.body.removeChild(div);
    // }
    console.log(window['gapi'])
  }, []);

  // const renderButton = (dat) => {
  //   console.log("Oye hoyeeeeeeeeeeeee")
  //   console.log(dat)
  // }

  return (
      <div id="app">
        <div id="content" style={{display: 'flex', height: '100vh'}}>
                <span style={{width: '10vw', height: '100vh'}}>
                    <Sidebar />
                </span>
                <span style={{width: '90vw', height: '100vh'}}>
                    <div style={{width: '100%', height: '10vh'}}>
                        <TopBar />
                    </div>
                    <div style={{width: '90vw', height: '91.5vh', overflowY: 'scroll', overflowX: 'visible'}}>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      A
                      assumenda numquam saepe tenetur totam
                      unde
                      veniam! Culpa cumque debitis delectus doloremque ducimus
                      explicabo
                      id illo, quia, quis quo
                      voluptatibus
                      voluptatum?</p>
                      
                    </div>
                    <div className="g-signin2" data-onsuccess="onSignIn"></div>
                </span>
            </div>
      </div>
  );
};
